import * as React from 'react';
import { Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store';
import { trainingActionCreators } from '../../store/Training';
import { TrainingType } from '../../types/TrainingTypes';
import ExternalLinksDropdown from '../card/ExternalLinksDropdown';
import Choice from './Choice';
import Combined from './Combined';
import Interpret from './Interpret';
import Main from './Main';
import CardActionsDropdown from './CardActionsDropdown';
import ServicePanelVisibilityDropdown from './ServicePanelVisibilityDropdown';

interface TrainingProps {
    trainingType: TrainingType;
    isPreview?: boolean;
    isHard?: boolean;
}

export default function Training(props: TrainingProps) {
    const { trainingType, isPreview, isHard } = props;
    const auth = useAppSelector(state => state.auth);
    const trainingState = useAppSelector(state => state.training);
    const guestDictionaryId = useAppSelector(state => state.dictionaries).dictionaryId;
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(trainingActionCreators.start(trainingType, isPreview ?? false, isHard ?? false, guestDictionaryId));
        document.title = `Training - ${(document as any).rootTitle}`;
    }, [dispatch, trainingType, isPreview, guestDictionaryId]);

    function onConfirmModeChanging() {
        dispatch(trainingActionCreators.confirmModeChanging());
    }

    return (
        <>
            <div className="flex-grow-1 d-flex flex-column align-items-center w-100"
                style={{ paddingTop: 'calc(min(40vh, 50vw) - 15rem)' }} >

                {trainingState.newModeName ?
                    <Button variant="light"
                        className="fs-4 w-100 width-limit"
                        style={{ marginTop: "10rem" }}
                        onClick={onConfirmModeChanging}>
                        <div className="fs-5">Next dictionary:</div>
                        <div>{trainingState.newModeName}</div>
                    </Button>
                    :
                    !trainingState.card ?
                        <div className="loader" />
                        :
                        <>
                            {trainingState.card.trainingType === TrainingType.Recollect &&
                                <Main />
                            }
                            {trainingState.card.trainingType === TrainingType.Interpret &&
                                <Interpret />
                            }
                            {trainingState.card.trainingType === TrainingType.Choice &&
                                <Choice />
                            }
                            {trainingState.card.trainingType === TrainingType.Combined &&
                                <Combined />
                            }

                            <div className="panel mb-2 my-2">
                                {trainingState.isSolutionShown && trainingState.isServicePanelEnabled
                                    ? <>
                                        {trainingState.card &&
                                            <>
                                                <ExternalLinksDropdown card={trainingState.card}
                                                    dictionaryPaths={trainingState.card.modeInfo} />

                                                {auth.user &&
                                                    <CardActionsDropdown card={trainingState.card} />
                                                }
                                            </>
                                        }
                                    </>
                                    :
                                    <ServicePanelVisibilityDropdown card={trainingState.card} />
                                }
                            </div>
                        </>
                }
            </div>
        </>
    );
}
